<div class="relative flex min-h-[50px] w-full">
  <span
    class="absolute"
    [ngClass]="{
      'custom-top custom-top_tags': !isForm,
      'top-[18px] text-[14px]': isForm && !thisTags.length,
      'top-[6px] text-[10px]': isForm && !!thisTags.length,
      'text-[#00000090]': isForm,
    }">
    {{ (label ? label : 'tags') | translate }}
  </span>
  <app-tags-button
    [ngClass]="{
      'folder-icon-form': isForm,
      'folder-icon': !isForm,
    }"
    [isMenu]="false"
    (click)="openAddTag.emit()"
    [label]="label ? label : 'tags'" />
  <div
    class="attachments"
    [ngClass]="{
      'tags-field h-[56px] max-h-[60px] xl:max-h-[60px]': isForm,
      'subject max-h-[50px] xl:max-h-[50px]': !isForm,
    }">
    <div
      class="app-tags tags-main flex w-[90%] flex-wrap items-center gap-x-4 gap-y-1 py-1">
      @for (tag of thisTags; track tag.tag) {
        <app-tag-component [tag]="tag" />
      }
    </div>
  </div>
</div>
